<template>
  <room-card v-bind="$attrs" />
</template>

<script>
import RoomCard from '../booking-wizard/components/room-card/room-card.vue'

export default {
  name: 'room-stay-card',
  components: {
    RoomCard
  },
}
</script>